import { useQuery } from '@tanstack/react-query'
import {
  getPushNotificationAlertStatus,
  isPushNotificationAvailable,
} from '@core/Utils/notifications/pushNotificationAlerts'
import { queryKeys } from '@core/Data/ReactQuery/constants'

export const useBlackbookPushAlertQuery = (accountNumber: number) =>
  useQuery({
    queryKey: [queryKeys.blackbookPushAlerts, accountNumber],
    queryFn: () => getPushNotificationAlertStatus(accountNumber, 'blackbook'),
    retry: false,
    enabled: isPushNotificationAvailable,
    refetchOnWindowFocus: false,
  })
